module.exports = __webpack_public_path__ + "img/breadth.e55384ca.svg";